// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorLegal = (client) => ({
    /**
     * `POST /vendor/legal/policies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalPoliciesCreate
     * @source apps/backend/src/api/vendor/legal/policies/route.ts
     */
    createPolicy: (body, query, headers) => client.fetch("/vendor/legal/policies", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/legal/policies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalPoliciesIdDelete
     * @source apps/backend/src/api/vendor/legal/policies/[id]/route.ts
     */
    deletePolicy: (id, body, query, headers) => client.fetch(buildPath("/vendor/legal/policies/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/legal/policies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalPoliciesRetrieve
     * @source apps/backend/src/api/vendor/legal/policies/route.ts
     */
    listPolicies: (query, headers) => client.fetch("/vendor/legal/policies", { method: "GET", query, headers }),
    /**
     * `GET /vendor/legal/products/:id/policies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalProductsIdPoliciesRetrieve
     * @source apps/backend/src/api/vendor/legal/products/[id]/policies/route.ts
     */
    listProductsPolicies: (id, query, headers) => client.fetch(buildPath("/vendor/legal/products/:id/policies", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/legal/policies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalPoliciesIdRetrieve
     * @source apps/backend/src/api/vendor/legal/policies/[id]/route.ts
     */
    retrievePolicy: (id, query, headers) => client.fetch(buildPath("/vendor/legal/policies/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/legal/vendor-legal`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalVendorLegalRetrieve
     * @source apps/backend/src/api/vendor/legal/vendor-legal/route.ts
     */
    retrieveVendorLegal: (query, headers) => client.fetch("/vendor/legal/vendor-legal", { method: "GET", query, headers }),
    /**
     * `POST /vendor/legal/policies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalPoliciesIdCreate
     * @source apps/backend/src/api/vendor/legal/policies/[id]/route.ts
     */
    updatePolicy: (id, body, query, headers) => client.fetch(buildPath("/vendor/legal/policies/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/legal/products/:id/policies/owner`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalProductsIdPoliciesOwnerCreate
     * @source apps/backend/src/api/vendor/legal/products/[id]/policies/owner/route.ts
     */
    updateProductsPoliciesOwner: (id, body, query, headers) => client.fetch(buildPath("/vendor/legal/products/:id/policies/owner", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/legal/products/:id/policies/seller-override`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalProductsIdPoliciesSellerOverrideCreate
     * @source apps/backend/src/api/vendor/legal/products/[id]/policies/seller-override/route.ts
     */
    updateProductsPoliciesSellerOverride: (id, body, query, headers) => client.fetch(buildPath("/vendor/legal/products/:id/policies/seller-override", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/legal/vendor-legal`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLegalVendorLegalCreate
     * @source apps/backend/src/api/vendor/legal/vendor-legal/route.ts
     */
    updateVendorLegal: (body, query, headers) => client.fetch("/vendor/legal/vendor-legal", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=legal.js.map